var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"},attrs:{"id":"my-strictly-unique-vue-upload-multiple-image"}},[_c('vue-upload-multiple-image',{on:{"upload-success":_vm.uploadImageSuccess,"before-remove":_vm.beforeRemove,"edit-image":_vm.editImage,"data-change":_vm.dataChange,"limit-exceeded":_vm.limitExceeded}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fdd6a67","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 68
// module chunks = 0